import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatEndDate, MatStartDate } from '@angular/material/datepicker';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/input';
import { TranslocoPipe } from '@jsverse/transloco';

import { BaseControlComponent } from '~components/form/base-control/base-control.component';
import { ErrorTooltipDirective } from '~core/directives/error-tooltip.directive';

@Component({
    selector: 'arc-date-range-picker',
    templateUrl: './date-range-picker.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        MatFormField,
        ErrorTooltipDirective,
        MatLabel,
        MatDateRangeInput,
        MatStartDate,
        ReactiveFormsModule,
        MatEndDate,
        MatDatepickerToggle,
        MatSuffix,
        MatDateRangePicker,
        TranslocoPipe
    ]
})
export class DateRangePickerComponent extends BaseControlComponent implements OnInit {
    @Input() controlEnd!: AbstractControl;
    @Input() min?: Date;
    @Input() max?: Date;
    @Input() showHint = true;

    dateFormat = '';

    get castedControlEnd(): FormControl {
        return this.controlEnd as FormControl;
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.dateFormat = this._translationService.current.dateFormat;
    }
}
